import Loadable from "@cores/loadable";

const LoadableDomainOverview = Loadable({
    loader: () => import('./DomainOverview'),
    loading: () => null
});

export default LoadableDomainOverview;
